import { Outlet } from "react-router-dom";
import CustomerTopMenu from "../../Components/Customer/CustomerTopMenu";
import VerticalNavigation from "../../Components/Layout/Navigation/VerticalNavigation";
import CustomerMenuItems from "../../Components/Layout/Navigation/MenuItems/CustomerMenuItems";
import {useSelector} from "react-redux";

export default function CustomerLayout({ }) {
    const sideMenuOpen = useSelector((state) => state.CommonReducer.sideMenuOpen);
    return (
        <div className={`page-holder${!sideMenuOpen? 'hidden-vert-menu' : ''}`}>
            <CustomerTopMenu />
            <VerticalNavigation>
                <CustomerMenuItems />
            </VerticalNavigation>
            <Outlet />
        </div>
    );
}